var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("LexonSelectComponent", {
    attrs: {
      id: "receiver",
      name: "receiver",
      label: _vm.receiverLabel,
      isMultiselect: "",
      renderChips: "",
      showAllChips: "",
      keyName: "name",
      keyValue: "id",
      validationRules: "required",
      serverPagination: "",
      tableHeaders: _vm.receiverTableHeaders,
      endPointEntity: _vm.receiverEndPointEntity,
      returnObject: "",
      validateOnLoad: "",
    },
    on: { input: _vm.emitReceiver },
    model: {
      value: _vm.receiver,
      callback: function ($$v) {
        _vm.receiver = $$v
      },
      expression: "receiver",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }